import AntdMessage from 'antd/lib/message';
import * as utils from './utils';
var Message = AntdMessage;
Message.utils = utils;
export default Message;